import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "prices",
    name: "Pricing",
    version: "0.2.0",
    tier: "addon",
    accent: "shop",
    dependsOn: ["sites"],
    description: "Banded shelf prices: build your own price bands and put each site in one (with department or till group exceptions), see every product's price and margin at every site, check RRPs against the Co-op's, tidy prices up by each band's rule (price-marked packs are never touched), and turn your changes into a price file for the head office PC, with the new price shown until the till has it.",
    permissions: {
        view: "See prices, margins, banding problems and the RRP check across sites",
        manage: "Queue price changes (and Tidy up), approve them into a price file, mark it sent",
        settings: "Build the bands, put sites in them, departments left out, price file columns, tools and switches",
    },
    grants: {
        "Head office": ["view", "manage", "settings"],
        "Area manager": ["view"],
    },
    tasks: [
        { key: "approve", title: "Price changes to approve", description: "Price changes are waiting to be approved into a price file. Clears when they're approved or removed.", level: "action", audience: "routed", clear: "fix", link: "/prices/changes", icon: "tag", sort: 10, notify: false },
        { key: "send", title: "Price file to send", description: "An approved price file hasn't been marked as sent to the head office PC yet. Clears when it's ticked off.", level: "action", audience: "routed", clear: "fix", link: "/prices/changes?tab=files", icon: "upload", sort: 20, notify: false },
        { key: "till", title: "Prices not on the till", description: "Prices sent in a price file that the till still doesn't show after the set number of days (3 to start with). Clears when the product import shows them, or a newer change replaces them.", level: "action", audience: "routed", clear: "fix", link: "/prices/changes?tab=till", icon: "alert-triangle", sort: 30, notify: false },
    ],
    // The set-up tool's questions (29/10/26), suggested from the company profile and written into Price bands → Tools
    // and the price ending (server.ts `questions`).
    questions: [
        {
            id: "shop-prices", ask: "Who sets your shop prices?",
            options: [
                { value: "central", label: "Head office, for every site", help: "Price files go to the head office back office." },
                { value: "site", label: "Each site, in its own back office", help: "Nozl shows each site's prices side by side." },
            ],
        },
        {
            id: "ending", ask: "How should suggested shelf prices end?",
            options: [
                { value: "9", label: "In 9p (£1.29)" },
                { value: "5", label: "In 5p or 0p (£1.25, £1.30)" },
                { value: "any", label: "Any penny" },
            ],
        },
    ],
    nav: [
        { label: "Pricing", path: "/prices", section: "shop", tab: "Pricing", tabIcon: "pound", permission: "view", icon: "pound", order: 20, blurb: "Every product's shelf price and margin at every site" },
        { label: "Price changes", path: "/prices/changes", section: "shop", tab: "Pricing", tabIcon: "pound", permission: "manage", icon: "list", order: 21, blurb: "Approve changes into a price file, send it, see it reach the till" },
        { label: "RRP check", path: "/prices/rrp", section: "shop", tab: "Pricing", tabIcon: "pound", permission: "view", icon: "check-circle", order: 22, blurb: "Our RRPs and shelf prices against the Co-op's RRP" },
        { label: "Price bands", path: "/prices/bands", section: "shop", kind: "settings", permission: "settings", icon: "layers", order: 23, blurb: "Your bands and their rules, the sites in each, the price file" },
    ],
});
